export default "__VITE_ASSET__CuW2fdAL__"